export default {
	nullOption() {
		return { display: "", value: null }
	},

	nullBankOption() {
		return { routingNumber: "", bankName: "", displayName: "" }
	},

	billingMethods(reimbursementAccount) {
		if (reimbursementAccount?.id) {
			return [
				{ display: `ACH from Reimbursement Account (${reimbursementAccount?.nickname})`, value: "REIMBURSEMENT" },
				{ display: `ACH from Billing Account`, value: "BILLING" },
				{ display: "Credit Card", value: "STRIPE" }
			]
		} else {
			return [
				{ display: `ACH from Billing Account`, value: "BILLING" },
				{ display: "Credit Card", value: "STRIPE" }
			]
		}
	},

	accountTypes: ["Checking", "Savings"]
}
